<template>
  <section class="widget brand-impact">
    <h3 class="widget-title">Impacto de su marca en el tiempo</h3>
    <card type="line-chart">
      <div class="card-top">
        <div class="card-header">
          <div class="icon-wrapper">
            <font-awesome-icon icon="eye" />
          </div>
          <h4 class="card-title">{{ graphicLabel }}</h4>
        </div>
        <div class="card-number">
          <h3>{{ Number(totalImpressions).toLocaleString() }}</h3>
        </div>
      </div>
      <div class="card-content">
        <apexchart
          ref="impChart"
          type="line"
          min-height="350"
          :options="getOptions"
          :series="getSeries"
        />
      </div>
    </card>
  </section>
</template>
<script>
export default {
  name: "impressions",
  props: {
    totalImpressions: Number,
    impressions: Array,
    yaxis: Object,
    graphicLabel: String
  },
  data() {
    return {
      series: [],
      impressionsChartOptions: {
        tooltip: {
          x: {
            show: true,
            format: "dd MMM",
            formatter: undefined
          },

          y: {
            formatter: function(
              value
              // { series, seriesIndex, dataPointIndex, w }
            ) {
              return value.toLocaleString();
            }
          }
        },
        responsive: [
          {
            breakpoint: undefined,
            options: {
              width: "100%"
            }
          }
        ],
        chart: {
          height: 350,
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 3,
          curve: "smooth",
          colors: "#3AB8FF"
        },
        grid: {
          row: {
            colors: ["#fff", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        xaxis: {
          categories: [
            "Jun '18",
            "Ago '18",
            "Oct '18",
            "Dic '18",
            "Feb '18",
            "Abr '18"
          ]
        }
      }
    };
  },
  created() {
    this.series = this.impressions.map(impresion => {
      return impresion.count;
    });
  },
  methods: {
    commaSeparateNumber: function(amount, decimals = 0) {
      amount += ""; // por si pasan un numero en vez de un string
      amount = parseFloat(amount.replace(/[^0-9.]/g, "")); // elimino cualquier cosa que no sea numero o punto

      decimals = decimals || 0; // por si la variable no fue fue pasada

      // si no es un numero o es igual a cero retorno el mismo cero
      if (isNaN(amount) || amount === 0) return parseFloat(0).toFixed(decimals);

      // si es mayor o menor que cero retorno el valor formateado como numero
      amount = "" + amount.toFixed(decimals);

      var amount_parts = amount.split("."),
        regexp = /(\d+)(\d{3})/;

      while (regexp.test(amount_parts[0]))
        amount_parts[0] = amount_parts[0].replace(regexp, "$1" + "," + "$2");

      return amount_parts.join(".");
    }
  },
  computed: {
    getSeries() {
      let result = this.impressions.map(impresion => {
        return impresion.count;
      });
      if (this.graphicLabel === "Visitas Totales") {
        return [
          {
            name: "Visitas",
            data: result
          }
        ];
      }
      return [
        {
          name: "Impresiones",
          data: result
        }
      ];
    },
    getOptions() {
      let result = this.impressions.map(impresion => {
        return new Date(impresion.date).getTime();
      });

      const impressionsChartOptions = {
        ...this.impressionsChartOptions,
        ...{
          xaxis: {
            categories: result,
            type: "datetime"
          }
        }
      };

      return impressionsChartOptions;
    }
  }
};
</script>
<style lang="scss" scoped></style>
